import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/02/13/principle/measurement.svg`,
        },
      },
      styles: {
        padding: "4%",
      },
    },
  },
];

export default components;
